import { Record } from "immutable";

import type { IEntityOption, TEntityOption } from "../utils/entityOptionType";

const defaults = {
  email: null as null | string,
  id: "",
  isDeleted: false,
  membersCount: null as null | number,
  name: "",
  selected: false,
  usage: {
    approvalAlgorithmRuleCount: 0,
    policyCount: 0,
  },
};

export class DirectoryGroupModel extends Record<typeof defaults>(defaults) implements IEntityOption<"DirectoryGroup"> {
  static fromServerData(data: unknown) {
    return new DirectoryGroupModel(data as typeof defaults);
  }

  toEntityOption(): TEntityOption<"DirectoryGroup"> {
    return {
      displayName: this.name,
      email: this.email,
      identifier: this.id,
      isDeleted: this.isDeleted,
      membersCount: this.membersCount,
      selected: this.selected,
      type: "DirectoryGroup",
      usage: this.usage,
    };
  }
}
